<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
        <g transform="translate(-16 -66)">
            <g transform="translate(3 -821)">
                <circle class="a" cx="17" cy="17" r="17" transform="translate(13 887)" 
                :fill="this.$vuetify.theme.dark ? '#A5D867' : '#ffffff'"/>
            </g>
            <g transform="translate(3.5 -62)">
                <path class="b" d="M3,0,6,6H0Z" transform="translate(27 136)" fill="#383935"/>
                <path class="b" d="M3,0,6,6H0Z" transform="translate(33 155) rotate(180)" fill="#383935"/>
                <g transform="translate(-115.5 175.5) rotate(-90)">
                    <path class="b" d="M3,0,6,6H0Z" transform="translate(27 136)" fill="#383935"/>
                    <path class="b" d="M3,0,6,6H0Z" transform="translate(33 155) rotate(180)" fill="#383935"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'GuideIcon'
}
</script>

<style scoped>
    svg {
        width:34px;
        height: 34px;
    }
</style>